import { useState } from "react";

const CopyableListSection = ({ title, items }) => {
  const [copied, setCopied] = useState(false);
  const [showList, setShowList] = useState(false);
  const [copiedIndex, setCopiedIndex] = useState(null);

  const handleCopyFullList = () => {
    navigator.clipboard.writeText(items.join(", ")).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  const handleCopyItem = (item, index) => {
    navigator.clipboard.writeText(item).then(() => {
      setCopiedIndex(index);
      setTimeout(() => setCopiedIndex(null), 1500);
    });
  };

  return (
    <div className="copy-section-wrapper">
      <div className="copy-inline-row">
        <label className="copy-label">{title}</label>
        <button className="copy-full-list-btn" onClick={handleCopyFullList}>
          {copied ? "Copied" : "Copy Full List"}
        </button>
        <button
          className="toggle-list-btn"
          onClick={() => setShowList((prev) => !prev)}
        >
          {showList ? "Hide List" : "Show List"}
        </button>
      </div>

      {showList && (
        <ul className="copy-list-items">
          {items.map((item, index) => (
            <li key={item} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span>{item}</span>
              <button
                className="copy-btn"
                onClick={() => handleCopyItem(item, index)}
              >
                {copiedIndex === index ? "Copied" : "Copy"}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CopyableListSection;
